// extracted by mini-css-extract-plugin
module.exports = {"article-containers":"article-containers--8s8qu","article-background-gradient":"article-background-gradient--8s8qu"};